import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, Stack, TextField } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import Loader3D from "../../components/Loader/Loader3D";
import {
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../components/mui/Buttons/Buttons";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getCartEditRequests,
  getTitleAndFields,
  makeCartEditRequest,
  updateCartEditRequest,
} from "../../redux/features/generalSlice";
import GlobalAutoCompleteMultiSelect from "../../components/mui/GlobalAutoCompleteMultiSelect";
import { useSnackbar } from "notistack";
import { savePaginationData } from "../../redux/features/globalDatagridSlice";
import dayjs from "dayjs";

const CartEditRequest = ({
  courseenrollmentId,
  dispatchdata,
  row,
  requestSection,
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, titleAndFields } = useSelector((store) => store.general);
  const { enqueueSnackbar } = useSnackbar();
  const { paginationData } = useSelector((state) => state.globalDataGrid);

  const getTitle = (name) => {
    const match = titleAndFields?.titles?.find(
      (title) => title.fieldName === name
    );
    return match ? match.id : "";
  };

  const initialValues = {
    title: getTitle(row?.request_title),
    description: row?.request_body,
    fields: row?.changeFields || [],
    courseEnrollmentId: courseenrollmentId,
    request_id: row?.request_id,
  };

  const schema = Yup.object({
    title: Yup.number().required("Title Required"),
    description: Yup.string().required("Description Required"),
    // fields: Yup.array().min(1, "At least one field is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = {
        ...values,
        course_enrollment_id: values.courseEnrollmentId,
        changeFields: titleAndFields?.titles.find((t)=>t?.id==values.title)?.fields || [],
      };
      if (row?.request_id) {
        dispatch(updateCartEditRequest(data)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(getCartEditRequests(dispatchdata));
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      } else {
        dispatch(makeCartEditRequest(data)).then((res) => {
          if (res.payload.status === "error") {
            enqueueSnackbar(res.payload.message, {
              variant: "error",
            });
          } else if (res.payload.status === "success") {
            handleCancel();
            dispatch(
              savePaginationData({ ...paginationData, openAnchor: false })
            );
            setTimeout(() => {
              navigate("/my-workspace/cart-edit");
            }, 1000);

            enqueueSnackbar(res.payload.message, {
              variant: "success",
            });
          }
        });
      }
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getTitleAndFields());
    }
  }, [open]);
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Make a request"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <Button
            disabled={
              !requestSection
                ? !row.requestEditable
                : false || dayjs().diff(dayjs(row?.cro_assigned_on), "day") > 3
            }
            size="small"
            sx={{
              p: "7px 10px",
              gap: "5px",
              background: "linear-gradient(108deg, #dcae0e, #00000052)",
              color: "#fff",
              "&:hover": {
                background:
                  "linear-gradient(108deg,rgb(220, 62, 14), #00000052)",
              },
            }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            Request
          </Button>
        </>
      }
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Stack gap={1}>
                      <Box>
                        <GlobalSelectField
                          options={{
                            formik: formik,
                            label: "Title",
                            name: "title",
                            data: titleAndFields?.titles,
                            keys: {
                              id: "id",
                              value: "fieldName",
                            },
                            sx: {
                              width: "100%",
                            },
                          }}
                        />
                      </Box>
                      <Box>
                        {/* <GlobalAutoCompleteMultiSelect
                          options={{
                            formik: formik,
                            label: "Fields",
                            name: "fields",
                            data: titleAndFields?.fields,
                            keys: {
                              id: "id",
                              value: "fieldName",
                            },
                            sx: {
                              width: "100%",
                            },
                          }}
                        /> */}
                        {/* <Autocomplete
                          fullWidth
                          multiple
                          name="fields"
                          options={titleAndFields?.fields}
                          getOptionLabel={(option) => option.fieldName}
                          renderOption={(props, option, { selected }) => {
                            const { key, ...optionProps } = props;
                            return (
                              <li key={key} {...optionProps}>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option.fieldName}
                              </li>
                            );
                          }}
                          value={titleAndFields?.fields?.filter((f) =>
                            formik.values.fields.includes(f.id)
                          )}
                          onChange={handleFieldChange}
                          renderInput={(params) => (
                            <TextField
                              disabled
                              fullWidth
                              autoComplete="off"
                              {...params}
                              label="Fields"
                              error={
                                formik.touched.fields &&
                                Boolean(formik.errors.fields)
                              }
                              helperText={
                                formik.touched.fields && formik.errors.fields
                              }
                            />
                          )}
                        /> */}
                      </Box>
                      <Box>
                        <TextField
                          type="text"
                          autoComplete="off"
                          fullWidth
                          id="description"
                          label="Description"
                          name="description"
                          value={formik.values.description}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.description &&
                            Boolean(formik.errors.description)
                          }
                          helperText={
                            formik.touched.description &&
                            formik.errors.description
                          }
                        />
                      </Box>
                    </Stack>
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                  >
                    <Stack direction={"row"} spacing={1}>
                      <CancelButton action={() => handleCancel()}>
                        Cancel
                      </CancelButton>
                      {false ? (
                        <UpdateButton disabled={loading} type="submit">
                          {loading ? "Updating..." : "Update Request"}
                        </UpdateButton>
                      ) : (
                        <SubmitButton disabled={loading} type="submit">
                          {loading ? "Submiting..." : "Submit"}
                        </SubmitButton>
                      )}
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default CartEditRequest;
